import React, { FunctionComponent, useMemo } from "react";
import useAcuratePercentage from "../hooks/useAcuratePercentage";

type OwnProps = {
  topOffset?: number;
  students: number[];
  statsByEc: {
    belowColor?: string;
    atOrAboveColor?: string;
    below: number[];
    atOrAbove: number[];
  } | null;
};

type Props = OwnProps;

const AtOrAboveCell: FunctionComponent<Props> = (props) => {
  const { statsByEc, students, topOffset } = props;
  const { getPercentages } = useAcuratePercentage();
  if (!statsByEc) {
    return null;
  }

  const atOrAboveCount = useMemo(
    () =>
      statsByEc.atOrAbove.filter((sId) => students.includes(sId)).length || 0,
    [statsByEc.atOrAbove]
  );

  const belowCount = useMemo(
    () => statsByEc.below.filter((sId) => students.includes(sId)).length || 0,
    [statsByEc.below]
  );

  return (
    <td
      className="text-center p-4 text-nowrap"
      //style={{ backgroundColor: statsByEc.atOrAboveColor, top: topOffset }}
      style={{ backgroundColor: "rgb(191, 249, 221)", top: topOffset }}
    >
       <strong>{`${getPercentages(belowCount, atOrAboveCount).atOrAbovePercent}%`}</strong>
       &nbsp;({atOrAboveCount})
    </td>
  );
};

export default AtOrAboveCell;
